import { AfterViewInit, Component, ElementRef, inject, OnInit, ViewChild } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { IframeCommunicationService } from '../shared/services/iframe-communication.service';
import { ConfigService } from '../shared/services/config-service';

@Component({
  selector: 'app-vendor-server',
  imports: [],
  templateUrl: './vendor-server.component.html',
  styleUrl: './vendor-server.component.css'
})
export class VendorServerComponent implements AfterViewInit {
  @ViewChild('embeddedClientFrame', { static: true }) embeddedFrame!: ElementRef<HTMLIFrameElement>;

  private readonly configService = inject(ConfigService);
 
  nectaOneSid: String = ''
  ngOnInit() {
   
  }


  ngAfterViewInit() {
    this.embeddedFrame.nativeElement.src = this.configService.getUrlVendorCatalogClient();
  }
}
